// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"526":"4fdc289e","993":"340dbc38"}[chunkId] + ".chunk.js";
};